module.exports = __webpack_public_path__ + "img/maintenance-of-dogs-ua.463a5d59.svg";